import type { AppStackParamList } from './AppNavigation.props';

/**
 * Mapping used to handle 301 redirects.
 */

export const redirectsMapping: Record<
  string,
  Readonly<{
    screen: keyof AppStackParamList;
    params: AppStackParamList[keyof AppStackParamList];
  }>
> = {
  '/location': {
    screen: 'MainTabs',
    params: {
      screen: 'MenuTab',
      params: { screen: 'Locations' },
    },
  },
  '/menu': {
    screen: 'MainTabs',
    params: {
      screen: 'AccountTab',
      params: {
        screen: 'AccountMenu',
      },
    },
  },
  '/profile': {
    screen: 'MainTabs',
    params: {
      screen: 'AccountTab',
      params: {
        screen: 'Profile',
      },
    },
  },
  '/account/profile': {
    screen: 'MainTabs',
    params: {
      screen: 'AccountTab',
      params: {
        screen: 'Profile',
      },
    },
  },
  '/challenges': {
    screen: 'MainTabs',
    params: {
      screen: 'LoyaltyTab',
      params: {
        screen: 'SweetpassHome',
      },
    },
  },
  '/sweetpass/membership': {
    screen: 'MainTabs',
    params: {
      screen: 'AccountTab',
      params: {
        screen: 'SweetpassMembership',
      },
    },
  },
  '/payment': {
    screen: 'MainTabs',
    params: {
      screen: 'AccountTab',
      params: {
        screen: 'PaymentAndGiftCards',
      },
    },
  },
  '/addresses': {
    screen: 'MainTabs',
    params: {
      screen: 'AccountTab',
      params: {
        screen: 'Addresses',
      },
    },
  },
  '/orders': {
    screen: 'MainTabs',
    params: {
      screen: 'AccountTab',
      params: {
        screen: 'Orders',
      },
    },
  },
  '/favorites': {
    screen: 'MainTabs',
    params: {
      screen: 'AccountTab',
      params: {
        screen: 'Favorites',
      },
    },
  },
  '/refer-friend': {
    screen: 'MainTabs',
    params: {
      screen: 'AccountTab',
      params: {
        screen: 'ReferFriend',
      },
    },
  },
  '/account-dietary-restrictions': {
    screen: 'MainTabs',
    params: {
      screen: 'AccountTab',
      params: {
        screen: 'AccountDietaryRestrictions',
      },
    },
  },
};
